import {
  EventSubscription,
  NativeEventEmitter,
  NativeModules,
} from 'react-native';

export const startRecognize = async (): Promise<any> => {
  return NativeModules.AzureModule.startRecognize();
};

export const stopRecognize = async (): Promise<any> => {
  return NativeModules.AzureModule.stopRecognize();
};

export const stopRely = async (): Promise<{text: string}> => {
  return NativeModules.AzureModule.stopRely();
};

export const stopSpeak = async (): Promise<any> => {
  return NativeModules.AzureModule.stopSpeak();
};
export const goAskQuestion = (text: string): void => {
  return NativeModules.AzureModule.goAskQuestion(text);
};
export const init = async (): Promise<any> => {
  console.log('触发init');
  return NativeModules.AzureModule.init();
};
const eventEmitter = new NativeEventEmitter(NativeModules.AzureModule);

export type CallBackType<T, S> = (arg: T) => S;
export type EventArgType = {
  data: string;
};

export type Events = {
  onRecognizing: CallBackType<EventArgType, void>;
  onRecognized: CallBackType<EventArgType, void>;
  onWelcomeGet: CallBackType<EventArgType, void>;
  onWelcomeSpeakEnd: CallBackType<EventArgType, void>;
  onRely: CallBackType<EventArgType, void>;
  onRelyEnd: CallBackType<EventArgType, void>;
  onSpeakEnd: CallBackType<EventArgType, void>;
  onError: CallBackType<EventArgType, void>;
  onInitEnd: CallBackType<EventArgType, void>;
};

export type EventCallbacks = {
  [K in keyof Events]: Events[K];
};

const addListener = <E extends keyof EventCallbacks>(
  eventName: E,
  callback: EventCallbacks[E],
): EventSubscription => {
  return eventEmitter.addListener(eventName, callback);
};

const AzureModule = {
  init,
  startRecognize,
  stopRecognize,
  stopRely,
  stopSpeak,
  goAskQuestion,
  eventEmitter,
  addListener,
};
export default AzureModule;
